import { Component, inject, OnInit } from '@angular/core';
import { AdminBoilerplateComponent } from '../../../../../core/admin-boilerplate/feature/admin-boilerplate.component';
import { HeadlineComponent } from '../../../../../events/headline/feature/headline.component';
import { Store } from '@ngrx/store';
import { selectAdminAvailableTickets, selectAdminEvent, selectAdminUnavailableTickets } from '../../../../../data-services/stores/selectors/admin.selectors';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { adminActions } from '../../../../../data-services/stores/actions/admin.actions';
import { EventTicketDetailed } from '../../../../../data-services/models/event-tickets/event-ticket-detailed.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EventComplete } from '../../../../../data-services/models/events/event-complete.model';
import { TicketsTableComponent } from '../table/table.component';
import { tap } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { NewComponent } from '../new/feature/new.component';


@Component({
  selector: 'app-tickets',
  imports: [AdminBoilerplateComponent, HeadlineComponent, CommonModule,FontAwesomeModule, TicketsTableComponent,DialogModule,NewComponent],
  templateUrl: '../ui/tickets.component.html',
  styleUrl: '../ui/tickets.component.css'
})
export class AdminEventTicketsComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);

  lrpEvent$ = this._store.select(selectAdminEvent(this._route.snapshot.params["id"]))
  availableTickets$ = this._store.select(selectAdminAvailableTickets(this._route.snapshot.params["id"]))
  unavailableTickets$ = this._store.select(selectAdminUnavailableTickets(this._route.snapshot.params["id"]))
    expandedRows = {};
  editRow?: number;

  showNewModal:boolean = false;

  ngOnInit(): void {
    this._store.dispatch(adminActions.getEvent({ eventRef: this._route.snapshot.params["id"] }))
  }

  canEdit =(eventTicket: EventTicketDetailed, event: EventComplete): boolean =>
    !new Set(event.eventBookings.flatMap(x => x.eventTickets.flatMap(y => y.ticketID))).has(eventTicket.ticketID)

  canDelete = (eventTicket: EventTicketDetailed, event: EventComplete): boolean =>
    !new Set(event.eventBookings.flatMap(x => x.eventTickets.flatMap(y => y.ticketID))).has(eventTicket.ticketID)  
}
